var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.291,
    viewBox: "0 0 20 16.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope-regular",
    d: "M18.125,64H1.875A1.961,1.961,0,0,0,0,66.036V78.254a1.961,1.961,0,0,0,1.875,2.036h16.25A1.961,1.961,0,0,0,20,78.254V66.036A1.961,1.961,0,0,0,18.125,64Zm0,2.036v1.731c-.876.775-2.272,1.979-5.257,4.518-.658.562-1.961,1.912-2.868,1.9-.907.016-2.21-1.335-2.868-1.9-2.985-2.538-4.381-3.743-5.257-4.518V66.036ZM1.875,78.254V70.38c.9.774,2.164,1.861,4.1,3.506.854.73,2.349,2.341,4.026,2.331,1.669.01,3.145-1.578,4.026-2.331,1.935-1.645,3.2-2.732,4.1-3.506v7.874Z",
    transform: "translate(0 -64)",
    fill: "#c248e0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.ab0eee4f852aad1cb63990de73ae598a.svg";
export { ForwardRef as ReactComponent };